import { render } from "./Troops.vue?vue&type=template&id=4c356a46"
import script from "./Troops.vue?vue&type=script&lang=js"
export * from "./Troops.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/villageOverview/Troops.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c356a46"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c356a46', __exports__)) {
    api.reload('4c356a46', __exports__)
  }
  
  module.hot.accept("./Troops.vue?vue&type=template&id=4c356a46", () => {
    api.rerender('4c356a46', render)
  })

}


export default __exports__